// client/src/utils/users.js
// ---------------------------------
// User profile API helpers
// ---------------------------------
import api from './api';

export async function fetchCurrentUser() {
    const response = await api.get('/users/me');
    return response.data;
}

export async function fetchUserDirectory() {
    const response = await api.get('/users/directory');
    return response.data;
}

export async function updateCurrentUser(payload) {
    const response = await api.put('/users/me', payload);
    return response.data;
}
